import React, {
  DragEvent,
  FunctionComponent,
  ReactNode,
  RefObject,
  useCallback,
  useRef,
} from "react";
import "./style.scss";

interface Props {
  children: ReactNode;
  draggable: boolean;
  noShadowImage?: boolean;
  onDragEnd: (ref: RefObject<HTMLDivElement>) => void;
  onDragStart: (event: { ref: RefObject<HTMLDivElement>; pageX: number; pageY: number }) => void;
}

const Draggable: FunctionComponent<Props> = ({
  children,
  draggable,
  noShadowImage = false,
  onDragEnd,
  onDragStart,
}) => {
  const dragRef = useRef<HTMLDivElement>(null);
  const dragStart = useCallback(
    (event: DragEvent) => {
      // To survive a component that rerenders
      if (event.target) {
        event.target.addEventListener("dragend", () => onDragEnd(dragRef), {
          once: true,
        });
      }

      setTimeout(() => onDragStart({ ref: dragRef, pageX: event.pageX, pageY: event.pageY }), 0);

      if (event.dataTransfer && event.target) {
        event.dataTransfer.setData("img", "");
        if (noShadowImage) {
          const image = new Image();
          image.src = "data:image/png;base64,";
          event.dataTransfer.setDragImage(image, 2000, 2000);
        }
        event.dataTransfer.effectAllowed = "move";
        event.dataTransfer.dropEffect = "move";
      }
    },
    [noShadowImage, onDragStart, onDragEnd]
  );

  return (
    <div
      className="Draggable"
      draggable={draggable}
      onDragStart={dragStart}
      onDragEnd={() => onDragEnd(dragRef)}
      ref={dragRef}
    >
      {children}
    </div>
  );
};

export default Draggable;
